import { useState, useEffect } from "react";

import './PartsServices.css';

import { SetListPag } from "interface/Page";
import { SetModalData, SetModalState } from "interface/PopUp";
import { GetDataPage, RegisterDataPage } from "interface/Data";

import { SvgDelete, SvgEdit, SvgSearch, SvgSetaDown, SvgSetaRight, SvgSetaUp } from "components/SvgFile";

import PopUP_OpenPartService from "components/PopUp/OpenPartService";

import { Reg_AltPositionPartService } from "services/RegisterData";

export default function Page_PartsServices(){
    
    const [ search, setSearch ]             = useState('');
    const [ showButton, setShowButton ]     = useState(GetDataPage('mesa_part_service_buttons'));
    const [ showDataPage, setShowDataPage ] = useState(GetDataPage('mesa_part_service_data'));

    useEffect(()=>{
        RegisterDataPage('mesa_part_service_data', setShowDataPage);
        RegisterDataPage('mesa_part_service_buttons', setShowButton);
    }, []);
    
    function SearchInput(value){
        const newData   = [];
        if(value !=''){
            {
                GetDataPage('mesa_part_service_data').forEach(item =>{
                    if(item.name_pt_br.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                    if(item.name_en.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                    if(item.name_es.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                    if(item.title_pt_br.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                    if(item.title_en.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                    if(item.title_es.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                    if(item.subtitle_pt_br.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                    if(item.subtitle_en.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                    if(item.subtitle_es.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                    if(item.nameOrigin.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newData.push(item);
                    }
                })
            }
            const duplicate = newData.filter((item, index) => newData.indexOf(item) === index);
            setShowDataPage(duplicate);

        }else if(value == ''){
            setShowDataPage(GetDataPage('mesa_part_service_data'));
        }
        setSearch(value);
    }

    function AltPosition(type, id, order_){
        Reg_AltPositionPartService(type, id, order_);
    }

    function OpenService(){
        SetModalState('OpenPartService', true);
    }

    function NewData(id){
        SetListPag('currentPage', 'mesa_part_service_details');
        SetListPag('currentPageId', id);
    }

    function DeleteData(id, value){
        SetModalData("Confirmation", { "id": id, "origin": "mesa_part_service", "type": "delete_data", "name": value });
        SetModalState('Confirmation', true);
    }

    return(
        <div className="Page_PartsServices">
            <div className="new_block">
                <div className="div_name_page">
                    <div className="name_fixed">
                        Dashboard
                    </div>
                    <div className="show_icon">
                        <SvgSetaRight color="#CDD1D6" className="icons" />
                    </div>
                    <div className="name_page">
                        Peças e serviços
                    </div>
                </div>
                <div className="input_search">
                    <SvgSearch color="#606875" className="icons_search" />
                    <input type="text" className="search" onChange={ (e)=>{ SearchInput(e.target.value) } } value={ search } required placeholder="buscar" />
                </div>
                <div className="list_opt_alt_page">
                    <div className="new_data" onClick={ ()=>{ OpenService() } }>
                        <div className="">
                            Tipos de serviços
                        </div>
                    </div>
                    <div className="new_block_text" onClick={ ()=>{ NewData(0) } }>
                        <div className="">
                            <span className="icons_menu">+</span>
                        </div>
                        <div className="">
                            Peças e serviços
                        </div>
                    </div>
                </div>
            </div>
            <div className="">                
                <table cellPadding="0" cellSpacing="0">
                    <thead>
                        <tr>
                            <th width="20">#</th>
                            <th width="160">Tipo</th>
                            <th>Nome</th>
                            <th width="160">Posição</th>
                            <th width="20" align="right">#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            showDataPage.length > 0 ?
                                showDataPage.map((key, index)=>{
                                    let data_type = '';
                                    let dataButton = showButton.find(item => item.id == key.id_given);
                                    if(dataButton){
                                        data_type   = dataButton.name_pt_br;
                                    }
                                    return(
                                        <tr key={ index }>
                                            <td align="left">{ index + 1 }</td>
                                            <td>{ data_type }</td>
                                            <td>{ key.name_pt_br }</td>
                                            <td>{ key.position == 'left' ? "Esquerda" : "Direita" }</td>
                                            <td align="right">
                                                <div className="list_opt">
                                                    {
                                                        index == 0 ? <div className="" style={ { width: '24px' } } /> :
                                                        <div className="" onClick={ ()=>{ AltPosition('up', key.id, key.order_) } } style={ { width: '24px' } }>
                                                            <SvgSetaUp className="icons" color="#2D3C53" />
                                                        </div>
                                                    }
                                                    {
                                                        showDataPage.length == (index + 1) ? <div className="" style={ { width: '24px' } } /> :
                                                        <div className="" onClick={ ()=>{ AltPosition('down', key.id, key.order_) } } style={ { width: '24px' } }>
                                                            <SvgSetaDown className="icons" color="#2D3C53" />
                                                        </div>
                                                    }
                                                    <div onClick={ ()=>{ DeleteData(key.id, key.name) } }>
                                                        <SvgDelete color="#F00000" className="icons"/>
                                                    </div>
                                                    <div onClick={ ()=>{ NewData(key.id) } }>
                                                        <SvgEdit color="#324d6b" className="icons"/>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            :
                            <tr>
                                <td colSpan="7">
                                    <div className="no_data">Nenhum dado encontrado...</div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <PopUP_OpenPartService />
        </div>
    )
}